import { createFileRoute, Link } from '@tanstack/react-router'
import { CHANGELOG, K_LABEL_KEY } from './-lib/changelog'
import { buildSeo } from './-lib/seo'
import { createSiteTranslate } from './-lib/site-i18n'

export const Route = createFileRoute('/(public)/changelog')({
	ssr: true,
	head: ({ match }) => {
		const { appLanguage } = match.context
		const t = createSiteTranslate(appLanguage)
		return buildSeo({
			appLanguage,
			path: '/changelog',
			title: t('site:seo.changelog.title'),
			description: t('site:seo.changelog.description')
		})
	},
	component: ChangelogPage
})

function ChangelogPage() {
	const { appLanguage } = Route.useRouteContext()
	const t = createSiteTranslate(appLanguage)

	return (
		<>
			<section className='doc-hero'>
				<div className='wrap'>
					<span className='eyebrow'>
						{t('site:changelog.hero.eyebrow')}
					</span>
					<h1>{t('site:changelog.hero.title')}</h1>
					<p>{t('site:changelog.hero.subtitle')}</p>
					<div className='doc-updated'>
						{t('site:changelog.hero.updated')}
					</div>
				</div>
			</section>

			<div
				className='wrap'
				style={{
					maxWidth: '780px',
					paddingTop: '48px',
					paddingBottom: '80px'
				}}
			>
				{CHANGELOG.map((entry) => (
					<div className='cl-entry' key={entry.version}>
						<div className='cl-ver'>
							<h3>{entry.version}</h3>
							<span className={`cl-tag ${entry.tagVariant}`}>
								{t(entry.tagKey)}
							</span>
							<span className='cl-date'>{t(entry.dateKey)}</span>
						</div>
						<ul className='cl-list'>
							{entry.items.map((item) => (
								<li key={item.textKey}>
									<span className={`k ${item.kVariant}`}>
										{t(K_LABEL_KEY[item.kVariant])}
									</span>
									<span>{t(item.textKey)}</span>
								</li>
							))}
						</ul>
					</div>
				))}

				<p
					style={{
						color: 'var(--faint)',
						fontSize: '13.5px',
						marginTop: '24px'
					}}
				>
					{t('site:changelog.footer_note')}{' '}
					<Link
						className='inl'
						style={{ color: 'var(--accent)' }}
						to='/support'
					>
						{t('site:changelog.footer_link')}
					</Link>
					.
				</p>
			</div>
		</>
	)
}
